import { buildRoute } from "routes";
import { AdApplicationInterface } from "types/ad";

export function getApplicationConversationUrl(application: AdApplicationInterface): string {
    const clientId = application.client_id ?? application.ad?.client_id;
    if (!clientId) {
        return buildRoute.messaging(application.service_id, "");
    }

    if (application.ad_id) {
        return buildRoute.messagingAd(application.service_id, clientId, application.ad_id);
    }

    return buildRoute.messaging(application.service_id, clientId);
}

export function isApplicationBookingCancelled(application: AdApplicationInterface): boolean {
    return Boolean(application.booking?.cancelled_at ?? application.ad?.booking?.cancelled_at);
}
